// ---------------------------------------------------------------------------
// Whether the map's color legend (Legend.tsx) is hidden — remembered across
// sessions in localStorage, same pattern as theme.ts.
// ---------------------------------------------------------------------------
import { readLocalStorage, writeLocalStorage } from "./localStoragePreference.ts";

const LOCAL_STORAGE_KEY = "evalhid-legend-hidden";

/** Visible by default. */
export function readLegendHidden(): boolean {
  return readLocalStorage(LOCAL_STORAGE_KEY) === "1";
}

export function saveLegendHidden(hidden: boolean): void {
  writeLocalStorage(LOCAL_STORAGE_KEY, hidden ? "1" : "0");
}
